/**
 * Global application configuration.
 * Can store run-time options, API urls, paths, execution flags and so on.
 * Automatically loaded on application initialization and available as app.config.
 */

'use strict';

module.exports = {
    searchInputDelay: 400,
    weatherServerURL: 'http://weather.infomir.com.ua/',
    getGeo:           'getGeo.php'
};
